<template>
  <div class="alert alert-info">
    {{ $t("THE_LAST_WORKING_DAY_HAS_REMAINED") }}
    {{ routemap.minutesToNextControl }} {{ $t("MINUTES_TO_QUALITY_CONTROL") }}.
    <br />
    {{ $t("PLEASE_CHECK_IN_AS_AN_OPERATOR_TO_START_THE_WORK_PROCESS") }}
  </div>
</template>

<script>
export default {
  props: {
    routemap: {
      required: true,
      type: Object
    }
  }
};
</script>

<style scoped></style>
